import * as Actions from "./constants";
import { put, call, takeEvery, all } from "redux-saga/effects";
import { addCompany, loadCompanies, deleteCompany, editCompany, updateCompany } from "./service";
/**
 * Create Company
 */
function* createCompany({ postData }) {
  try {
    const { data } = yield call(addCompany, postData);
    yield put({
      type: Actions.CREATE_COMPANY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.CREATE_COMPANY_ERROR,
      error: error,
    });
  }
}
/**
 * Load all masters
 */
function* listCompanies() {
  try {
    const { data } = yield call(loadCompanies);
    yield put({
      type: Actions.GET_ALL_COMPANY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_ALL_COMPANY_ERROR,
      error: error,
    });
  }
}
/**
 * Delete Company
 */
function* deleteCompanyData(id) {
  try {
    const { data } = yield call(deleteCompany, id);
    yield put({
      type: Actions.DELETE_COMPANY_SUCCESS,
      payload: "deleted",
    });
  } catch (error) {
    yield put({
      type: Actions.DELETE_COMPANY_ERROR,
      error: error,
    });
  }
}
/**
 * Edit Company
 */
function* editCompanyData(id) {
  try {
    const { data } = yield call(editCompany, id);
    yield put({
      type: Actions.EDIT_COMPANY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.EDIT_COMPANY_ERROR,
      error: error,
    });
  }
}
/**
 * Update Company
 */
function* updateCompanyData({ postData }) {
  try {
    // const phoneNumber = parseInt(postData.phoneNumber);
    // if (isNaN(phoneNumber) || String(phoneNumber) !== postData.phoneNumber) {
    //   throw new Error("Phone number must be a valid integer.");
    // }
    const { data } = yield call(updateCompany, postData);
    yield put({
      type: Actions.UPDATE_COMPANY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.UPDATE_COMPANY_ERROR,
      error: error,
    });
  }
}
export default function* companySaga() {
  yield takeEvery(Actions.CREATE_COMPANY, createCompany);
  yield takeEvery(Actions.GET_ALL_COMPANY, listCompanies);
  yield takeEvery(Actions.DELETE_COMPANY, deleteCompanyData);
  yield takeEvery(Actions.EDIT_COMPANY, editCompanyData);
  yield takeEvery(Actions.UPDATE_COMPANY, updateCompanyData);
}
